import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs';
import { IUser } from '../../../../models/user.model';
import { VotingData } from '../../../../providers/voting';
import { NavParams, ViewController } from 'ionic-angular';
import { Store } from '@ngrx/store';
import { UtilitiesProvider } from '../../../../providers/utilities';
import { EventData } from '../../../../providers/event';
import { ENV } from '@app/env';
import { switchMap } from 'rxjs/operators';
import { PageTrack } from '../../../../shared/decorators/analytics';
import * as userSelectors from '../../../../ngrx/reducers/auth.reducer';
import * as clientSelectors from '../../../../ngrx/reducers/client.reducer';
import uniqid from 'uniqid';

const uidTrack = uniqid();
const pageName = 'VotingActiveComponent';
@Component({
  selector: 'app-voting-active',
  templateUrl: 'voting-active.html'
})
@PageTrack(uidTrack, pageName)
export class VotingActiveComponent implements OnInit {
  public clientId: string;
  public eventId: string;
  public votingId: string;
  public ponderationType: 'code' | 'email';
  public ponderationValue: string;
  public activeVoting$: Observable<any>;
  public config$: Observable<any>;
  public userInformationSubs: Subscription;
  public userInformation: IUser;
  public showQuestions: boolean = false;

  constructor(
    private votingData: VotingData,
    private navParams: NavParams,
    private store: Store<{}>,
    private viewCtrl: ViewController,
    private utilities: UtilitiesProvider,
    private eventData: EventData
  ) { }

  ngOnInit() {
    this.clientId = this.navParams.get('clientId');
    this.eventId = this.navParams.get('eventId');
    this.votingId = this.navParams.get('votingId');
    this.ponderationType = this.navParams.get('ponderationType');
    this.getUserInformation();
    this.getVotingActive();
    this.getConfig();
    this.utilities.consoleDecorator('this.ponderationType', this.ponderationType)
  }

  /**
   * Get User Information
   * @author Sebastián Guevara
   */
  private getUserInformation() {
    this.userInformationSubs = this.store.select(userSelectors.getUser)
      .subscribe((userInformation: IUser) => {
        this.userInformation = userInformation;
      })
  }

  /**
   * Get the module configuration
   * 1. If it's an event get the eventInfo
   * 2. If has custom_styles get the ClientInfo
   * 2. If not it's an event get the ClientInfo
   */
  private getConfig() {
    if (this.utilities.validateEventIdParam(this.getEventId())) {
      this.config$ = this.eventData.getEventInfo(ENV.client, this.getEventId())
        .pipe(
          switchMap((eventInfo) => {
            if (eventInfo && eventInfo.custom_style === true) {
              // this.moduleState$ = this.eventData.getModuleState(ENV.client, this.getEventId(), 'commercial_samples');
              return Observable.of(eventInfo);
            }
            return this.store.select(clientSelectors.getClientConfig);
          }));
    } else {
      this.config$ = this.store.select(clientSelectors.getClientConfig);
      // this.moduleState$ = this.store.select(clientSelectors.getClientSingleModule('catalog'));
    }

  }

  public getClientId(): string {
    return ENV.client;
  }

  /**
   * return the clientId
   */
  public getEventId(): string {
    return this.navParams.get('eventId');
  }

  /**
   * Get Voting Active
   * Based on clientId and VotingId
   * @author Sebastián Guevara
   */
  private getVotingActive() {
    this.activeVoting$ = this.votingData.getVotingByClientId(this.clientId, this.votingId);
  }

  /**
   * Set showQuestions variable to show or not the questions
   * @param show
   * @author Sebastián Guevara
   */
  public setShowQuestions(event: string) {
    this.ponderationValue = event;
    this.showQuestions = true;
  }

  /**
   * Close Modal
   * @author Sebastián Guevara
  */
  public closeModal() {
    this.viewCtrl.dismiss();
  }

  ngOnDestroy() {
    if (this.userInformationSubs) this.userInformationSubs.unsubscribe();
  }
}


// WEBPACK FOOTER //
// ./src/pages/voting/components/voting-active/voting-active.ts